import { render, staticRenderFns } from "./LeoHandB.vue?vue&type=template&id=0b6cd670&scoped=true&"
import script from "./LeoHandB.vue?vue&type=script&lang=js&"
export * from "./LeoHandB.vue?vue&type=script&lang=js&"
import style0 from "./LeoHandB.vue?vue&type=style&index=0&id=0b6cd670&scoped=true&lang=less&"
import style1 from "./LeoHandB.vue?vue&type=style&index=1&id=0b6cd670&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6cd670",
  null
  
)

export default component.exports